<template>
  <div class="animated fadeIn"></div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {};
  },

  methods: {},

  mounted() {},
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

